import React from "react";
import { Button } from "@/components/ui/button";
import { Square, Circle, Volume2, VolumeX } from "lucide-react";

/**
 * VideoRecordingMode - Video recording component for Camera
 * Handles video recording UI and controls
 */
const VideoRecordingMode = ({
	isRecording,
	recordingDuration,
	formatDuration,
	onStartRecording,
	onStopRecording,
	onUserInteraction,
	isInitializing,
	hasPermission,
	isMuted,
	onToggleMute,
}) => {
	return (
		<div className="relative flex h-full w-full flex-col items-center justify-center">
			{/* Recording indicator - positioned below header to avoid overlapping post type badge */}
			{isRecording ? (
				<div className="absolute left-4 top-16 z-10 flex items-center gap-2 rounded-md bg-red-500 px-3 py-1.5 text-sm font-semibold text-white">
					<span className="h-2 w-2 animate-pulse rounded-full bg-white" />
					Recording {formatDuration(recordingDuration)}
				</div>
			) : null}

			{/* Mute/Unmute button - pushed below the header's close (X) + flip-camera
			    stack so it doesn't overlap them. */}
			{isRecording ? (
				<div className="absolute right-4 top-32 z-10">
					<Button
						onClick={onToggleMute}
						size="icon"
						variant="outline"
						className={`h-10 w-10 rounded-full border-2 ${
							isMuted
								? "border-red-500 bg-red-500/20 text-red-500"
								: "border-white bg-white/20 text-white"
						}`}
					>
						{isMuted ? <VolumeX size={20} /> : <Volume2 size={20} />}
					</Button>
				</div>
			) : null}

			{/* Capture/Stop button - centered above bottom controls */}
			<div className="absolute bottom-24 left-1/2 -translate-x-1/2 transform sm:bottom-28">
				{isRecording ? (
					<Button
						onClick={() => {
							onStopRecording();
							if (onUserInteraction) {
								onUserInteraction();
							}
						}}
						size="lg"
						className="h-14 w-14 rounded-full bg-red-500 p-0 shadow-lg hover:bg-red-600 sm:h-16 sm:w-16"
					>
						<Square size={24} className="fill-white text-white sm:h-7 sm:w-7" />
					</Button>
				) : (
					<Button
						onClick={() => {
							onStartRecording();
							if (onUserInteraction) {
								onUserInteraction();
							}
						}}
						disabled={isInitializing || !hasPermission}
						size="lg"
						className="h-14 w-14 rounded-full bg-white p-0 shadow-lg hover:bg-gray-100 disabled:opacity-50 sm:h-16 sm:w-16"
					>
						<Circle size={50} className="fill-black stroke-gray-200 stroke-1" />
					</Button>
				)}
			</div>
		</div>
	);
};

export default VideoRecordingMode;
